import { useEffect, useRef } from 'react';
export class CancelledPromiseError extends Error {
  constructor() {
    super('promise cancelled');
    this.name = 'CancelledPromiseError';
  }
}
function makeCancelable(promise) {
  let isCanceled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(value => isCanceled ? reject(new CancelledPromiseError()) : resolve(value)).catch(error => isCanceled ? reject(new CancelledPromiseError()) : reject(error));
  });
  return {
    promise: wrappedPromise,
    cancel() {
      isCanceled = true;
    }
  };
}
export function useCancellablePromise() {
  const promises = useRef([]);
  useEffect(() => {
    return cancelPromises;
  }, []);
  function cancellablePromise(p) {
    const cPromise = makeCancelable(p);
    promises.current.push(cPromise);
    return cPromise.promise;
  }
  function cancelPromises() {
    promises.current.forEach(p => p.cancel());
    promises.current = [];
  }
  return {
    cancellablePromise,
    cancelPromises
  };
}